export default [{
    path: '/collectMoney/paperRepair',
    component: resolve => require(['../page.vue'], resolve),
    meta: {
        title: '修护开卡',
        keepAlive: false
    }
}, {
    path: '/collectMoney/paperRepair/pageLast',
    name: '/collectMoney/paperRepair/pageLast',
    component: resolve => require(['../pageLast.vue'], resolve),
    meta: {
        title: '修护档案',
        keepAlive: true
    }
}, {
    path: '/collectMoney/paperRepair/edit',
    name: '/collectMoney/paperRepair/edit',
    component: resolve => require(['../edit.vue'], resolve),
    meta: {
        title: '修护登记',
        keepAlive: false
    }
}, {
    path: '/collectMoney/paperRepair/oldEdit',
    name: '/collectMoney/paperRepair/oldEdit',
    component: resolve => require(['../oldEdit.vue'], resolve),
    meta: {
        title: '修护登记',
        keepAlive: false
    }
}]